var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "#373737"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Section 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16772 -3489C-16772 -3490.1 -16771.1 -3491 -16770 -3491H12754C12755.1 -3491 12756 -3490.1 12756 -3489V11429C12756 11430.1 12755.1 11431 12754 11431H-16770C-16771.1 11431 -16772 11430.1 -16772 11429V-3489Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16770 -3490H12754V-3492H-16770V-3490ZM12755 -3489V11429H12757V-3489H12755ZM12754 11430H-16770V11432H12754V11430ZM-16771 11429V-3489H-16773V11429H-16771ZM-16770 11430C-16770.6 11430 -16771 11429.6 -16771 11429H-16773C-16773 11430.7 -16771.7 11432 -16770 11432V11430ZM12755 11429C12755 11429.6 12754.6 11430 12754 11430V11432C12755.7 11432 12757 11430.7 12757 11429H12755ZM12754 -3490C12754.6 -3490 12755 -3489.55 12755 -3489H12757C12757 -3490.66 12755.7 -3492 12754 -3492V-3490ZM-16770 -3492C-16771.7 -3492 -16773 -3490.66 -16773 -3489H-16771C-16771 -3489.55 -16770.6 -3490 -16770 -3490V-3492Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "2. Landing Page",
    clipPath: "url(#clip0_2301_7556)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 1029,
    transform: "translate(-650 -419)",
    fill: "#F9FDFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 48098772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6456",
    filter: "url(#filter0_dddddd_2301_7556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-218 -353C-218 -361.284 -211.284 -368 -203 -368H269C277.284 -368 284 -361.284 284 -353V441C284 449.284 277.284 456 269 456H-203C-211.284 456 -218 449.284 -218 441V-353Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6457"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-177 44.5154C-177 42.0216 -174.978 40 -172.485 40H239.485C241.978 40 244 42.0216 244 44.5154V75.4846C244 77.9784 241.978 80 239.485 80H-172.485C-174.978 80 -177 77.9784 -177 75.4846V44.5154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-172.485 39.5C-175.255 39.5 -177.5 41.7455 -177.5 44.5154V75.4846C-177.5 78.2545 -175.255 80.5 -172.485 80.5H239.485C242.255 80.5 244.5 78.2545 244.5 75.4846V44.5154C244.5 41.7455 242.255 39.5 239.485 39.5H-172.485Z",
    stroke: "#9E9E9E",
    strokeOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4860",
    d: "M-650 -419H716V610H-650V-419Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 239549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 479",
    d: "M-138 -30C-138 -41.0457 -129.046 -50 -118 -50H186.409C197.454 -50 206.409 -41.0457 206.409 -30V228.073C206.409 239.119 197.454 248.073 186.409 248.073H-118C-129.046 248.073 -138 239.119 -138 228.073V-30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2230",
    cx: 34.5,
    cy: 22.5,
    r: 38.5,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "help-desk 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6199 9.74572C22.398 9.74572 21.3956 10.748 21.3956 11.9733V13.9779C21.3956 15.2033 22.3979 16.2022 23.6199 16.2022H25.8476C28.5913 13.0888 27.286 10.6247 25.6911 9.74561L23.6199 9.74572Z",
    fill: "#9FD4FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7107 16.2026H46.0806L46.9375 16.5079C46.9375 16.5079 47.5151 16.2827 47.8424 16.0715C48.7 15.7616 49.3158 14.9376 49.3158 13.9782V11.9737C49.3158 10.7483 48.3169 9.74609 47.0915 9.74609H44.8638C43.1424 10.5319 42.866 14.8508 44.7107 16.2026Z",
    fill: "#9FD4FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3957 13.9782C21.3957 15.2036 22.398 16.2025 23.6201 16.2025H25.8477C26.3305 15.6564 26.6867 15.127 26.9399 14.6242H25.6944H23.6199C22.398 14.6242 21.3956 13.622 21.3956 12.3999L21.3957 13.9782Z",
    fill: "#85BEEF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8639 14.6242H43.6785C43.8816 15.2802 44.2246 15.8463 44.7107 16.2025H46.9616H47.0915C48.3169 16.2025 49.3158 15.2003 49.3158 13.9782V12.3999C49.3158 13.622 48.3169 14.6242 47.0915 14.6242H46.9616H44.8639Z",
    fill: "#85BEEF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7182 23.1158C36.8359 23.4454 36.0567 23.6086 35.2808 23.6086C34.5016 23.6086 33.7224 23.4454 32.8401 23.1158C32.0343 22.8161 31.2551 22.3999 30.5259 21.897V27.5411L34.6482 30.9409H35.9101L37.7814 29.3992L38.7803 28.5767L40.0323 27.5411V21.897C39.3065 22.3997 38.5274 22.8161 37.7182 23.1158Z",
    fill: "#F5A96C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2808 23.6082C34.5016 23.6082 33.7224 23.445 32.8401 23.1154C32.0343 22.8157 31.2551 22.3995 30.5259 21.8966V24.7203C31.5048 25.8158 35.3141 27.2676 37.7715 26.0022V29.3354L40.0324 26.2952V23.1418V21.8965C39.3065 22.3993 38.5274 22.8155 37.7182 23.1153C36.8359 23.4452 36.0567 23.6082 35.2808 23.6082Z",
    fill: "#EA9A58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1931 44.3463L35.2809 35.6754L27.5092 27.2676C26.1007 27.797 24.6023 28.473 23.2106 29.3088C20.8764 30.714 18.8419 32.5786 18.0461 34.9762C17.8131 35.6721 17.6865 36.4147 17.6865 37.2038V43.2642C17.6365 44.1266 17.8429 44.3463 18.6887 44.3463H29.3406H33.1931Z",
    fill: "#375E7D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.872 37.2039C52.872 32.0793 47.5077 28.9425 43.0491 27.2676L35.2808 35.6754L37.585 44.3463H51.8697C52.7188 44.3463 52.9219 44.1266 52.872 43.2642V37.2039Z",
    fill: "#375E7D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8004 44.3466L37.2321 35.6757L35.2808 34.6201L33.3263 35.6757L31.758 44.3466H35.2808H38.8004Z",
    fill: "#EB5468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2807 34.6201L33.3261 35.6757L33.0698 37.1042H35.4359C35.6063 37.1042 35.7524 37.2261 35.7827 37.3938L37.0422 44.3466H38.8004L37.2321 35.6757L35.2807 34.6201Z",
    fill: "#E5384F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8604 32.2123L37.7815 30.7611L35.2808 30.2144L32.8553 30.6143L31.7013 32.2123L33.3263 35.6754H35.2808H37.2321L38.8604 32.2123Z",
    fill: "#EB5468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2808 30.2144H32.8553L31.7013 32.2123L32.4871 33.8872L33.7923 33.158L35.1088 32.4246C35.2157 32.3651 35.3458 32.3652 35.4525 32.425L36.9524 33.2645L38.0711 33.8872L38.8603 32.2123L37.9947 30.6731L35.2808 30.2144Z",
    fill: "#E5384F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2807 30.2147L30.5258 26.2954C29.6368 26.5351 28.5979 26.8582 27.5091 27.2678L30.2626 32.596C30.3539 32.7726 30.5729 32.8388 30.7467 32.7423L31.7013 32.2126L35.2807 30.2147Z",
    fill: "#EFF6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0491 27.2678C41.9603 26.8582 40.9247 26.5352 40.0324 26.2954L35.2808 30.2147L38.8602 32.2127L39.8146 32.7423C39.9884 32.8388 40.2075 32.7725 40.2988 32.5958L43.0491 27.2678Z",
    fill: "#EFF6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0492 27.2678C41.9604 26.8582 40.9247 26.5352 40.0324 26.2954L38.7805 27.3276L37.7816 28.1501C38.7239 28.4498 39.7494 28.8228 40.7884 29.2723C41.1213 29.4156 41.451 29.5687 41.7807 29.7252L43.0492 27.2678Z",
    fill: "#D9EEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.872 37.2039C52.872 32.0793 47.5077 28.9425 43.0491 27.2676L41.7805 29.725C46.2391 31.3999 49.2093 34.5366 49.2093 39.6613V44.3464H51.8698C52.7189 44.3464 52.9219 44.1267 52.872 43.2643V37.2039Z",
    fill: "#2B4D66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8639 14.8504V12.383C43.5353 9.35283 29.5669 2.06707 25.6945 13.0856V14.8504C25.6945 18.2902 28.9277 22.6057 32.8802 24.0708C33.7459 24.3937 34.5117 24.5536 35.2809 24.5536C36.0467 24.5536 36.8126 24.3937 37.6816 24.0708C41.6307 22.6057 44.8639 18.2901 44.8639 14.8504Z",
    fill: "#FFBC85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8639 8.94336C44.8639 1.90733 33.5361 -1.60225 29.9899 3.00284C25.3582 3.41244 25.6978 9.57601 25.6978 10.3885L25.6944 12.3831V13.0857C28.9676 10.6549 27.8821 11.2643 30.2195 9.81913C33.7891 7.61477 36.8225 12.3831 42.483 12.3831H44.8638L44.8639 8.94336Z",
    fill: "#375E7D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9592 22.8726C41.7972 21.6006 43.3089 19.7692 44.1481 17.8911C44.6076 16.8655 44.864 15.8233 44.864 14.851V12.3836C43.8983 11.5578 42.8462 11.1849 41.8039 12.3603V14.851C41.8039 17.6015 39.7395 20.9114 36.8892 22.8794C36.1766 23.3722 35.4141 23.7784 34.6217 24.0715C34.3187 24.1847 34.0324 24.2746 33.7493 24.3479C34.2788 24.4877 34.7782 24.5543 35.281 24.5543C36.0469 24.5543 36.8127 24.3944 37.6817 24.0715C38.474 23.7784 39.2433 23.3655 39.9592 22.8726Z",
    fill: "#F5A96C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8039 12.3601C42.027 12.3767 42.2534 12.3833 42.4832 12.3833H44.864V8.94353C44.864 3.54911 38.2078 0.229279 33.5028 1.04849C37.5918 1.67453 41.8039 4.65476 41.8039 8.94353V12.3601Z",
    fill: "#2B4D66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M47.8427 16.0723V18.9234C47.8427 21.0074 46.1475 22.7048 44.0647 22.7048H35.9132C35.4269 22.7048 35.0322 22.3102 35.0322 21.8238C35.0322 21.3363 35.4269 20.9428 35.9132 20.9428H44.0647C45.176 20.9428 46.0806 20.0359 46.0806 18.9234V16.2027H47.0921C47.3553 16.2027 47.6078 16.1569 47.8427 16.0723Z",
    fill: "#375E7D"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_2301_7556",
    x: -298,
    y: -448,
    width: 662,
    height: 984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2301_7556"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0531481 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2301_7556",
    result: "effect2_dropShadow_2301_7556"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0425185 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2301_7556",
    result: "effect3_dropShadow_2301_7556"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.7407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2301_7556",
    result: "effect4_dropShadow_2301_7556"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.4259
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0274815 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2301_7556",
    result: "effect5_dropShadow_2301_7556"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0168519 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2301_7556",
    result: "effect6_dropShadow_2301_7556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2301_7556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2301_7556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 1029,
    fill: "white",
    transform: "translate(-650 -419)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDesk);
export default __webpack_public_path__ + "static/media/help-desk.0154cc3244c04bfe4247a44a61e29634.svg";
export { ForwardRef as ReactComponent };